import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'components/Tooltip';
import { FieldLabel } from '../../styled';
import { CLAIM_TYPES } from '../../../../consts';

const DateLabel = ({ claimType }) => {
  if (claimType === CLAIM_TYPES.TRAVEL) {
    return <FieldLabel>Date of event</FieldLabel>;
  }
  return (
    <FieldLabel>
      First date of service
      <Tooltip variant="grey">
        First date on which you have received medical service.
      </Tooltip>
    </FieldLabel>
  );
};

DateLabel.propTypes = {
  claimType: PropTypes.string
};

export default DateLabel;
